export default function() {
    return (
        <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M-0.00390625 2.50028C-0.00390625 1.39105 0.890194 0.496948 1.99943 0.496948H6.08693C6.48377 0.496948 6.8678 0.65683 7.14909 0.938121L9.06159 2.85062C9.1553 2.94433 9.28377 2.99695 9.41193 2.99695H19.9994C21.1087 2.99695 22.0028 3.89105 22.0028 5.00028V18.0003C22.0028 19.1095 21.1087 20.0036 19.9994 20.0036H1.99943C0.890194 20.0036 -0.00390625 19.1095 -0.00390625 18.0003V2.50028Z" fill="#A4344E"/>
        </svg>
    )
}